<template>
    <div>
        
        <InfoBox modalName="Hotspotheutejournal">
            <template #title>Erste Meldungen in Deutschland</template>
            <template #subline>ZDF Nachrichten vom 28.04.1986</template>
            <template>
                <p>
                <ZDFPlayer data-jsb='{"config":"https://3d.zdf.de/Tschernobyl/video/3Dconfiguration.json", "content":"https://3d.zdf.de/Tschernobyl/video/200420_hjo_Tschernobyl_Web.json"}'></ZDFPlayer>
                </p>

                <p>Erst zwei Tage nach der Katastrophe sickern Informationen nach Deutschland durch. Erhöhte Radioaktivität in der Luft wird in Schweden
                    und Finnland gemessen.
                </p>

                <!--<FullscreenImage v-bind:src="require('../assets/img/dummy-fullscreen.jpg')">-->
                <FullscreenImage v-bind:src="'img/3a_foto_1.jpg'">
                    <figure>
                        <img class="img-fluid" src="img/3a_foto_1_thumb.jpg" alt="">
                        <!--<figcaption>Quelle: images/ukrinform</figcaption> -->
                    </figure>
                </FullscreenImage>


            
                <p>Luftströme verteilen gefährliche  radioaktive Substanzen über die Nordhalbkugel, insbesondere Europa. In Deutschland trifft es vor allem den Süden.
                </p>
                <p></p>
                <p></p>

            </template>
        </InfoBox>
        
        <Fallback>
            <picture>
                <source media="(orientation: portrait)" srcset="../assets/img/fallback/04_Wolke_iPad_P.jpg">
                <source media="(orientation: landscape)" srcset="../assets/img/fallback/04_Wolke_iPad_L.jpg">
                <!-- The img element is required as the last child tag of the picture declaration block. The img element is used to provide backward compatibility for browsers that do not support the picture element, or if none of the source tags matched. -->
                <img src="../assets/img/fallback/Infobox.png" alt="">
            </picture>          
            <div class="hotspot" v-on:click="infobox('Hotspotheutejournal')"></div>	
        </Fallback>

    </div>
</template>

<script>
    export default {
        name: 'intro2',
        babylonState: {
            //moveCamera: [-7, 1.57 , 40, 13.5, 5, 0],     
            moveCamera: [-7, 1.55 , 30, 13.5, 7, 0],       
            hotspot: {
                visible: true,
                infoBox: 'Hotspotheutejournal', // Muss zur Infobox oben passen!
                position: [17.5,5.5, -2],
                scale: 3.5,
                //scale: 0,

                needDepthPrePass: true,
                alphaIndex: 5,
                renderingGroupId: 2,
            },

            Geo_Explosion: true,

            Geo_Tschernobyl: {

                children: {

                    BG_Sphere: true,

                    Strahl_1: {
                        visible: false,
                        //diffuse: [0,0.5,1]
                    },    
                    Strahl_2: {
                        visible: true,
                        //diffuse: [0,0.5,1]                    
                    },

                },

            },

            fire: false
        },

        babylonReady: function () {

            //this.$audioController.initTrack('speaker', require('./../assets/audio/Uebergang_01.mp3'), false, true);
            this.$babylonController.setAutoRotateBehaviour(true),
            this.$babylonController.setCameraRadiusLimit (5,110),
            this.$babylonController.zoomCamera(1)
            
        },

    }
</script>

<style scoped lang="scss">

    .fallback-container .hotspot {
        
        left: 65vw;
        top: 40vh;

        @media (orientation: landscape) {
            left: 60vw;
            top: 35vh;
            transform: scale(0.75);            
        }
    }


</style>
